import React from 'react';
import { IconProps } from '../assets/images/svg';
import { AttentionIcon } from '../assets/images/svg/attentionicon';
import { CalendarIcon } from '../assets/images/svg/calendaricon';
import { InformationIcon } from '../assets/images/svg/informationicon';
import { PaymentIcon } from '../assets/images/svg/paymenticon';
import { SignatureIcon } from '../assets/images/svg/signatureicon';
import { MessageDocumentActionType } from '../enums';

export function getActionCodeText(actionCode: string) {
    switch (actionCode) {
        case MessageDocumentActionType.Payment:
            return 'ACTION_CODE_PAYMENT';
        case MessageDocumentActionType.SelfService:
            return 'ACTION_CODE_SELFSERVICE';
        case MessageDocumentActionType.Information:
            return 'ACTION_CODE_INFORMATION';
        case MessageDocumentActionType.Signature:
            return 'ACTION_CODE_SIGNATURE';
        case MessageDocumentActionType.Confirmation:
            return 'ACTION_CODE_CONFIRMATION';
        case MessageDocumentActionType.Preparation:
            return 'ACTION_CODE_PREPARATION';
        case MessageDocumentActionType.Registration:
            return 'ACTION_CODE_REGISTRATION';
        case MessageDocumentActionType.Reservation:
            return 'ACTION_CODE_RESERVATION';
        default:
            return 'ACTION_CODE_MULTIPLE';
    }
}

export function getLabelText(label: string) {
    switch (label) {
        case MessageDocumentActionType.Payment:
            return 'ACTION_CODE_PAYMENT';
        case MessageDocumentActionType.SelfService:
            return 'ACTION_CODE_SELFSERVICE';
        case MessageDocumentActionType.Information:
            return 'ACTION_CODE_INFORMATION';
        case MessageDocumentActionType.Signature:
            return 'ACTION_CODE_SIGNATURE';
        case MessageDocumentActionType.Confirmation:
            return 'ACTION_CODE_CONFIRMATION';
        case MessageDocumentActionType.Preparation:
            return 'ACTION_CODE_PREPARATION';
        case MessageDocumentActionType.Registration:
            return 'ACTION_CODE_REGISTRATION';
        case MessageDocumentActionType.Reservation:
            return 'ACTION_CODE_RESERVATION';
        default:
            return 'ACTION_CODE_MULTIPLE';
    }
}

export const getMemoActionLokalizeId = (actionCode: string): string => {
    switch (actionCode) {
        case MessageDocumentActionType.Payment:
            return 'ACTION_CODE_PAYMENT_DESCRIPTION';
        case MessageDocumentActionType.SelfService:
            return 'ACTION_CODE_SELFSERVICE_DESCRIPTION';
        case MessageDocumentActionType.Information:
            return 'ACTION_CODE_INFORMATION_DESCRIPTION';
        case MessageDocumentActionType.Signature:
            return 'ACTION_CODE_SIGNATURE_DESCRIPTION';
        case MessageDocumentActionType.Confirmation:
            return 'ACTION_CODE_CONFIRMATION_DESCRIPTION';
        case MessageDocumentActionType.Preparation:
            return 'ACTION_CODE_PREPARATION_DESCRIPTION';
        case MessageDocumentActionType.Registration:
            return 'ACTION_CODE_REGISTRATION_DESCRIPTION';
        case MessageDocumentActionType.Reservation:
            return 'ACTION_CODE_RESERVATION_DESCRIPTION';
        default:
            return 'ACTION_CODE_INFORMATION_DESCRIPTION';
    }
};

export const getMemoActionIcon = (actionCode: string): React.FunctionComponent<IconProps> => {
    switch (actionCode) {
        case MessageDocumentActionType.Payment:
            return PaymentIcon;
        case MessageDocumentActionType.SelfService:
            return InformationIcon;
        case MessageDocumentActionType.Information:
            return InformationIcon;
        case MessageDocumentActionType.Signature:
            return SignatureIcon;
        case MessageDocumentActionType.Confirmation:
            return AttentionIcon;
        case MessageDocumentActionType.Preparation:
            return AttentionIcon;
        case MessageDocumentActionType.Registration:
            return AttentionIcon;
        case MessageDocumentActionType.Reservation:
            return CalendarIcon;
        default:
            return InformationIcon;
    }
};
